import TeamActions from "@/components/teams/team-actions";
import TeamsList from "@/components/teams/teams-list";
import { useAuthStore } from "@/data/useAuthStore";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { useActiveClub } from "../data/clubs/hooks";

export const Route = createFileRoute("/teams")({
  component: RouteComponent,
  loader() {
    const activeClubId = useAuthStore.getState().activeClubId;

    if (!activeClubId) {
      return redirect({
        to: "/home",
      });
    }
  },
});

function RouteComponent() {
  const userClub = useActiveClub();

  return (
    <div className="mx-auto p-4 bg-gradient-to-br from-[#2b7fff]/10 to-[#fe9a00]/10 w-full h-full">
      <div className="flex items-center sm:items-start justify-between mb-6 flex-col sm:flex-row gap-4">
        <div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-[#2b7fff] to-[#fe9a00] bg-clip-text text-transparent">
            Teams
          </h1>
          <p className="text-gray-500">View all teams and their rankings</p>
          {userClub && !userClub.isPro && (
            <p className="text-sm text-gray-400 mt-1">
              Pro clubs can have unlimited teams. Free clubs are limited to 2
              teams, but pro users can create unlimited teams in any club.
            </p>
          )}
        </div>

        <TeamActions />
      </div>

      <TeamsList />
    </div>
  );
}
